import { Injectable } from '@angular/core';
import { BaseService } from './base.service';

import { JpgOrPngConversionResponse } from '../models/JpgOrPngConversionResponse';
import { HttpClient } from '@angular/common/http';
import { JpgOrPngConversionRequest } from '../models/JpgOrPngConversionRequest';

@Injectable({
  providedIn: 'root'
})
export class ConversionService extends BaseService {

  constructor(private http:HttpClient) {
    super();
  }

  convertJpgOrPng(file_url: string,conversion_type: string) {

      let fc = new JpgOrPngConversionRequest();
      fc.file_url = file_url;
      fc.conversion_type = conversion_type;
      var route = `${this.baseUrl}/convert-jpg-or-png`;
      return this.http.post<JpgOrPngConversionResponse>(route, fc);
    }

}
